var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":"","disabled":!_vm.matchGame},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({staticClass:"caption",class:{
          blue: _vm.isGamePlaying,
          green: _vm.isGameCompleted,
          orange: _vm.isGameRequiresAttention,
          black: _vm.isGameWaiting,
          'white--text':
            _vm.isGamePlaying ||
            _vm.isGameCompleted ||
            _vm.isGameRequiresAttention ||
            _vm.isGameWaiting
        },attrs:{"label":"","x-small":"","outlined":_vm.outlined}},'v-chip',attrs,false),on),[_c('v-icon',{class:{
            'white--text':
              _vm.isGamePlaying ||
              _vm.isGameCompleted ||
              _vm.isGameRequiresAttention ||
              _vm.isGameWaiting
          },attrs:{"left":"","x-small":""}},[_vm._v(_vm._s(_vm.stateIcon))]),_vm._v(" "+_vm._s(_vm.$t('MatchGameState.' + _vm.state))+" ")],1)]}}])},[(_vm.matchGame)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('BracketMatchManageDialog.Game', { currentGameRound: _vm.matchGame.currentRound, totalGameRound: _vm.matchGame.totalRound }))+" ")]):_vm._e()]),(_vm.matchGame && _vm.isGameWaiting && !_vm.hideCheckInStatus)?_c('v-chip',{staticClass:"ml-2",attrs:{"x-small":"","outlined":_vm.outlined}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v("mdi-account-group")]),_vm._v(" "+_vm._s(_vm.$t('BracketMatchGameChips.CheckedIn', { current: _vm.matchGame.checkIn, total: _vm.matchGame.checkInTotal }))+" ")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }